export default "__VITE_ASSET__BbJq3zIO__"